import { stringify } from 'qs';
import { TypesenseSearchProps } from 'types';

export function typesenseOptionsToUrlQuery(options: TypesenseSearchProps) {
  return stringify(options);
}